"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSInsuranceoptionComponent = void 0;
const generic_content_service_1 = require("../services/generic.content.service");
class CSInsuranceoptionComponent {
    constructor(genericContentService) {
        this.genericContentService = genericContentService;
    }
    ngOnInit() {
        this.getInsuranceOptionsContent();
    }
    getInsuranceOptionsContent() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericInsuranceContent').subscribe((data) => {
            this.insuranceOptionsContent = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSInsuranceoptionComponent = CSInsuranceoptionComponent;
//# sourceMappingURL=insuranceoption.component.js.map